import React from 'react';
import { PurchaseFeaturesPanel, Subtitle } from './PurchaseFeaturesPanel';
import { DownloadButton } from './DownloadButton';

const metartIntimateFeatures = [
  'Self shot beautiful girls',
  'Authentic, candid, and intimate',
  'Unique and unexpected films',
  'Raw and uninhibited',
  'Yours to keep forever',
  'Unmatched customer support',
  'Never before seen',
  'HD and UHD 4K films',
];

type Props = {
  onPurchase: React.MouseEventHandler<HTMLButtonElement>;
};

export const MetartIntimatePurchasePanel = (props: Props) => {
  return (
    <PurchaseFeaturesPanel
      headline={
        <>
          THE WORLD&apos;S MOST BEAUTIFUL GIRLS
          <br />
          EXCLUSIVE CINEMATIC EROTICA
        </>
      }
      subtitle="What are you waiting for?"
      purchaseFeatures={metartIntimateFeatures}
    >
      <DownloadButton onClick={props.onPurchase}>Own It Now</DownloadButton>
      <Subtitle>YOU GET</Subtitle>
    </PurchaseFeaturesPanel>
  );
};
